// extracted by css-extract-rspack-plugin
export default {"label":"label-DRpotL"};